import React from 'react';
import PropTypes from 'prop-types';

import ResponsiveBGImage from '../../Util/ResponsiveBGImage/ResponsiveBGImage';
import FlagView from '../Flag/FlagView';

// Import assets
import './smImageTile.scss';
import '../../../../assets/icons/Icon_Instagram.svg';

const icon = (iconType) => {
  switch (iconType) {
    case 'instagram':
      return (<use xlinkHref="#Icon_Instagram" />);
    case 'youtube':
      return (<use xlinkHref="#Icon_YouTube_Black" />);
    case 'vimeo':
      return (<use xlinkHref="#Icon_Vimeo" />);
    default:
      return null;
  }
};

const SMImageTileView = props => (
  <a href={props.url}>
    <FlagView flag={props.flag} flagColor={props.flagColor} flagOrientation={props.flagOrientation} />
    <ResponsiveBGImage
      className="m-tile__inner m-tile--sm-image"
      src={{
        default: props.image.default,
      }}
      disableZoom
    >
      <div className="m-tile__content">
        <div className="m-tile__sm-image-icon">
          <svg>
            {icon(props.icon)}
          </svg>
        </div>

        <div className="m-tile__sm-image-text">
          <span className="m-tile__sm-image-headline">{props.headline}</span>
          <span className="m-tile__sm-image-subheadline">{props.subline}</span>
        </div>
      </div>
    </ResponsiveBGImage>
  </a>
);

SMImageTileView.propTypes = {
  url: PropTypes.string,
  headline: PropTypes.string,
  subline: PropTypes.string,
  flag: PropTypes.string,
  flagColor: PropTypes.string,
  flagOrientation: PropTypes.string,
  image: PropTypes.shape(),
  icon: PropTypes.string,
};

SMImageTileView.defaultProps = {
  url: '/',
  headline: '',
  subline: '',
  image: {},
  flag: '',
  flagColor: 'black',
  flagOrientation: 'left',
  icon: '',
};

export default SMImageTileView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/SMImageTile/SMImageTileView.jsx